<template>
  <div class="pattern-input">
    <div class="pattern-grid">
      <button 
        v-for="i in 9" 
        :key="i-1" 
        class="dot-btn" 
        :class="{ active: modelValue && modelValue.split('-').includes(String(i-1)) }"
        @click="onClick(i-1)"
      ></button>
    </div>
    <div class="controls">
       <button class="reset" type="button" @click="reset">پاک کردن</button>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
const props = defineProps({
  modelValue: String
})
const emit = defineEmits(['update:modelValue'])

function onClick(idx) {
  const s = String(idx)
  const current = props.modelValue ? props.modelValue.split('-') : []
  
  if (current.includes(s)) return
  current.push(s)
  emit('update:modelValue', current.join('-'))
}

function reset() {
  emit('update:modelValue', '')
}
</script>

<style scoped>
.pattern-input {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.pattern-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  background: #f1f5f9;
  padding: 16px;
  border-radius: 12px;
}
.dot-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #cbd5e1;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
}
.dot-btn.active {
  background: #2563eb;
  box-shadow: 0 0 0 4px rgba(37,99,235,0.2);
}
/* Optional: Draw lines? CSS only lines are hard without SVG. 
   For now, highlights are sufficient as MVP visual
*/
.reset {
  background: none;
  border: 1px solid #e2e8f0;
  color: #64748b;
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
}
.reset:hover { background: #f8fafc; color: #ef4444; border-color: #fee2e2; }
</style>
